import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { FaEdit, FaTrash } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";
import { MdOutlineEmail } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import { ClipLoader } from "react-spinners";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import LeaseApiService from "../../services/apiService";

const RFQ_TYPE = "request for quotation";
const isRfq = (type) => String(type?.label || "").trim().toLowerCase() === RFQ_TYPE;

const Activity = ({ activityRating, woContact, language, activityStatus, setActivityList, activityList, ativityLeadType, onSendEmail }) => {

    const apiService = React.useRef(new LeaseApiService()).current;
    const [propertyOptions, setPropertyOptions] = useState([]);
    const [unitOptions, setUnitOptions] = useState([]);

    const [formData, setFormData] = useState({
        type: null,
        property: null,
        unit: null,
        purpose: null,
        status: null,
        followup: null,
        visitDate: null,
        rating: null,
        wayofCOntact: null,
        language: null,
        remarks: '',
    });

    const [editIndex, setEditIndex] = useState(null);
    const showPropertyUnit = isRfq(formData.type);

    // "Send email" (Edit page only, passed in as onSendEmail) for Request For Quotation rows
    const [emailRow, setEmailRow] = useState(null);
    const [sendingEmail, setSendingEmail] = useState(false);
    const confirmSendEmail = async () => {
        setSendingEmail(true);
        try {
            await onSendEmail(emailRow);
        } finally {
            setSendingEmail(false);
            setEmailRow(null);
        }
    };

    // Property list: Customer controller dropdown "ActivityProperties"
    useEffect(() => {
        (async () => {
            try {
                const params = new URLSearchParams();
                params.append('dropdownTypes', 'ActivityProperties');
                const res = await apiService.getApiParamater('CUSTOMER_MULTI', `?${params.toString()}`);
                setPropertyOptions((res?.data?.dropdowns?.ActivityProperties || []).map((p) => ({ value: p, label: p?.text })));
            } catch (e) {
                console.error('Error loading properties:', e);
            }
        })();
    }, [apiService]);

    // Units of the selected property: Customer controller cascade "GetUnitsForPrefByproperty", CascadValue = property no
    const loadUnits = async (property) => {
        setUnitOptions([]);
        const propertyNo = property?.value?.value;
        if (!propertyNo) return;
        try {
            const params = new URLSearchParams();
            params.append('DropdownFor', 'GetUnitsForPrefByproperty');
            params.append('CascadValue', propertyNo);
            const res = await apiService.getApiParamater('CUSTOMER_CASCAD', `?${params.toString()}`);
            setUnitOptions((res?.data?.items || []).map((u) => ({ value: u?.value, label: u?.text })));
        } catch (e) {
            console.error('Error loading units:', e);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSelectChange = (name, selected) => {
        if (name === "type") {
            // Property / Unit only apply to "Request For Quotation"
            setFormData(prev => isRfq(selected)
                ? { ...prev, type: selected }
                : { ...prev, type: selected, property: null, unit: null });
            if (!isRfq(selected)) setUnitOptions([]);
        } else if (name === "property") {
            setFormData(prev => ({ ...prev, property: selected, unit: null }));
            loadUnits(selected);
        } else {
            setFormData(prev => ({ ...prev, [name]: selected }));
        }
    };
    const handleAddOrUpdate = () => {

        if (editIndex !== null) {
            const updatedList = activityList.map((item, i) =>
                i === editIndex ? { ...formData } : item
            );
            setActivityList(updatedList);
            setEditIndex(null);
        } else {
            // Newest first: the backend saves only ActivityList[0] (Rating, Way of Contact, Followup, ...)
            setActivityList(prev => [{ ...formData }, ...prev]);
        }

        setUnitOptions([]);
        setFormData({
            type: null,
            property: null,
            unit: null,
            purpose: null,
            status: null,
            followup: null,
            visitDate: null,
            remarks: '',
        });
    };
    const handleEdit = (index) => {
        setFormData({ ...activityList[index] });
        const saved = activityList[index]?.property;
        loadUnits(propertyOptions.find((o) => o.label === saved?.label) || saved);
        setEditIndex(index);
    };
    const handleDelete = (index) => {
        const filtered = activityList.filter((_, i) => i !== index);
        setActivityList(filtered);
    };
    const handleDateChange = (input) => {
        const value = input?.target?.value || input.value;
        const name = input?.target?.name || input.name;
        const updatedValue = typeof value === 'string' ? value : formatDate(value);
        setFormData(prev => ({ ...prev, [name]: updatedValue }));
    }
    const formatDate = (date) => date ? new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    }) : "";

    return (
        <div className="cost-center-section my-3">
            <div className="border-box2 p-3" style={{ borderRadius: '8px' }}>

                <div className="form-group grid-contain ">

                    {/* Contact Type */}
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Type</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={ativityLeadType?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.type}
                            onChange={(selected) => handleSelectChange("type", selected)}
                        />
                    </div>
                    {showPropertyUnit && (
                        <>
                            <div className="d-flex">
                                <label className="form-label pt-1 start">Property</label>
                                <Select
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                    isClearable
                                    options={propertyOptions}
                                    value={formData.property}
                                    onChange={(selected) => handleSelectChange("property", selected)}
                                />
                            </div>
                            <div className="d-flex">
                                <label className="form-label pt-1 start">Unit</label>
                                <Select
                                    className="p-0 w-100"
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                    isClearable
                                    isDisabled={!formData.property}
                                    options={unitOptions}
                                    value={formData.unit}
                                    onChange={(selected) => handleSelectChange("unit", selected)}
                                />
                            </div>
                        </>
                    )}
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Rating</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={activityRating?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.rating}
                            onChange={(selected) => handleSelectChange("rating", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Way of Contact</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={woContact?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.wayofCOntact}
                            onChange={(selected) => handleSelectChange("wayofCOntact", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Preferred Language</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={language?.map(country => ({ value: country?.value, label: country?.text }))}
                            value={formData.language}
                            onChange={(selected) => handleSelectChange("language", selected)}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Status</label>
                        <Select
                            className="p-0 w-100"
                            theme={(theme) => ({
                                ...theme,
                                borderRadius: 5,
                                padding: 9,
                            })}
                            menuPortalTarget={document.body}
                            styles={{
                                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                option: (provided, state) => ({
                                    ...provided,
                                    backgroundColor: state.isFocused ? "#F5F5F5 " : null,
                                    color: state.isFocused ? "#000 " : "#000",
                                    ":hover": {
                                        backgroundColor: "#F5F5F5",
                                        color: "#000 ",
                                    },
                                }),
                            }}
                            options={activityStatus?.map(country => ({ value: country?.value, label: country?.text }))}
                            onChange={(selected) => handleSelectChange("status", selected)}
                            value={formData.status}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Action Taken /<br /> Remarks</label>
                        <input
                            type="text"
                            className="p-2 form-control w-75"
                            name="remarks"
                            value={formData.remarks}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Followup</label>
                        <DatePicker
                            selected={formData.followup}
                            onChange={(date) => handleDateChange({ name: 'followup', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                    <div className="d-flex">
                        <label className="form-label pt-1 start">Visit Date</label>
                        <DatePicker
                            selected={formData.visitDate}
                            onChange={(date) => handleDateChange({ name: 'visitDate', value: date })}
                            dateFormat="dd-MMM-yyyy"
                            className="p-2 form-control w-100"
                        />
                    </div>
                </div>

                {/* ADD / UPDATE BUTTON */}
                <div className='my-4'>
                    <div
                        className='mainbtnSecondary flex-end gap-2 col-2'
                        style={{ cursor: "pointer" }}
                        onClick={handleAddOrUpdate}
                    >
                        <FaPlus color='#fff' className='center mt-1 mx-2' />
                        <div className='center'>
                            {editIndex !== null ? "Update Activity" : "Add Activity"}
                        </div>
                    </div>
                </div>

                {/* TABLE */}
                <div className='table-container' style={{ overflowX: 'auto', height: "400px" }}>
                    <table className='table table-bordered gridshad'>
                        <thead className='dynoTable'>
                            <tr>
                                <th>Action</th>
                                <th>Way of Contact</th>
                                <th>Type</th>
                                <th>Property</th>
                                <th>Unit</th>
                                <th>Followup</th>
                                <th>Remarks</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {activityList.map((data, index) => (
                                <tr key={index}>
                                    <td className="text-center d-flex gap-3">
                                        <div className='center mt-2'>
                                            <FaEdit
                                                size={20}
                                                style={{ cursor: "pointer", color: "black" }}
                                                onClick={() => handleEdit(index)}
                                            />
                                        </div>
                                        {onSendEmail && isRfq(data.type) && (
                                            <div className='center mt-2'>
                                                <MdOutlineEmail
                                                    size={22}
                                                    title="Send email"
                                                    style={{ cursor: "pointer", color: "#6E5199" }}
                                                    onClick={() => setEmailRow(data)}
                                                />
                                            </div>
                                        )}
                                        <div className='center mt-2'>
                                            <FaTrash
                                                size={20}
                                                style={{ cursor: "pointer", color: "red" }}
                                                onClick={() => handleDelete(index)}
                                            />
                                        </div>
                                    </td>
                                    <td>{data.wayofCOntact?.label}</td>
                                    <td>{data.type?.label}</td>
                                    <td>{data.property?.label}</td>
                                    <td>{data.unit?.label}</td>
                                    <td>{formatDate(data.followup)}</td>
                                    <td>{data.remarks}</td>
                                    <td>{data.status?.label}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

            </div>

            <Modal show={!!emailRow} onHide={() => !sendingEmail && setEmailRow(null)} centered>
                <Modal.Body className="p-4">
                    <h6 className="mb-3">Send Email</h6>
                    <div>
                        Send the Request For Quotation email
                        {emailRow?.property?.label ? ` for ${emailRow.property.label}${emailRow?.unit?.label ? ` - Unit ${emailRow.unit.label}` : ''}` : ''}?
                    </div>
                    <div className="d-flex justify-content-end gap-2 mt-4">
                        <button className="btn btn-secondary" disabled={sendingEmail} onClick={() => setEmailRow(null)}>Cancel</button>
                        <button className="btn btn-primary" disabled={sendingEmail} onClick={confirmSendEmail}>
                            {sendingEmail ? <ClipLoader size={14} color="#fff" /> : "OK"}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
};

export default Activity;